export const DEFAULT_ERROR_MESSAGE = [
  'Something went wrong. Please try again!',
];

export const COMMON_ERROR_ALERT_CHANGE_EVENT =
  'COMMON_ERROR_ALERT_CHANGE_EVENT';
